<template>
    <div class="pt-2 px-1 pb-4 text-justify">
        <h1 class="font-bold">小睡眠社区规范协议</h1>
        <p class="text-left font-bold">发布时间：2021年1月25日</p>
        <p class="text-left font-bold">生效时间：2021年1月25日</p>
        <p class="text-left font-bold">更新时间：2024年9月5日</p>
        <p>《小睡眠社区规范协议》（「本协议」）以引述的方式纳入《小睡眠服务协议》（「服务协议」），为服务协议不可分割的一部分。</p>
        <h2>总则</h2>
        <p>营造良好的社区氛围，鼓励理性、有效的沟通，维护小睡眠用户的合法权益，小睡眠将依据服务协议和本协议中的规定，管理小睡眠用户在小睡眠内的相关言论以及发布的内容。</p>
        <h2>我们倡导</h2>
        <p>1.本着原创、分享、互助、有爱的原则发布帖子、评论互动、关注私信等交流活动</p>
        <p>2.理性、宽容地看待不同的看法、喜好、意见等，欢迎有独特审美、不同品位的用户</p>
        <p>3.尊重他人著作权、隐私权、个人信息权益等</p>
        <p>4.遵守宪法和法律法规</p>
        <p>5.践行社会主义核心价值观</p>
        <p>6.弘扬爱国主义、集体主义和社会主义</p>
        <p>7.传播正确的历史观、民族观、国家观和文化观</p>
        <p>8.弘扬中华民族优秀传统文化</p>
        <p>9.弘扬社会公德、职业道德、家庭和个人美德，尊重公序良俗</p>
        <p>10.弘扬科学精神、普及科学知识</p>
        <p>11.提倡积极健康向上的时代风尚和生活方式</p>
        <h2>遵守基本原则</h2>
        <p>小睡眠平台禁止发布和传播包含下列信息的内容</p>
        <p>1.违反宪法所确定的基本原则的</p>
        <p>2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的</p>
        <p>3.损害国家荣誉和利益的，如损害国旗国徽形象的</p>
        <p>4.煽动民族仇恨、民族歧视，破坏民族团结的</p>
        <p>5.破坏国家宗教政策，宣扬邪教和封建迷信的</p>
        <p>6.散布谣言，扰乱社会秩序，破坏社会稳定的</p>
        <p>7.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的</p>
        <p>8.侮辱或者诽谤他人，侵害他人合法权益的</p>
        <p>9.宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的</p>
        <p>10.侮辱滥用英烈形象，否定歪曲英烈事迹，美化或粉饰侵略者和侵略战争行为的</p>
        <p>11.攻击诋毁党和国家领导人，捏造领导人负面信息，滥用领导人形象的</p>
        <p>12.违背公序良俗的内容，如低俗婚闹等</p>
        <p>13.含有法律、行政法规禁止的其他内容的</p>
        <h2>保护未成年人权益</h2>
        <p>为更好地保护未成年人合法权益和社会责任，小睡眠对不利于未成年人身心健康的内容会加以严肃处理，包括但不限于以下内容：</p>
        <p>1.涉及未成年人色情低俗的，如展示未成年人婚育、性侵害等</p>
        <p>2.涉及未成年人暴力欺凌的，如施暴犯罪、残害体罚、校园欺凌等</p>
        <p>3.涉及披露未成年人隐私的，如展现未成年人性器官，公开个人隐私等</p>
        <p>4.涉及未成年人不良行为的，如宗教传授、饮酒吸烟、邪典动画等</p>
        <p>5.涉及规避未成年人系统监管的，如故意规避防沉迷、青少年模式的方法攻略</p>
        <p>6.其他危害未成年人安全和健康的相关内容</p>
        <h2>我们不欢迎</h2>
        <p>1. 违反法律法规的内容：包括但不限于《互联网信息服务管理办法》第十五条，《网络信息内容生态治理规定》第六条所禁止发布的各类违法信息。</p>
        <p>2. 诉诸人身的评论：借由与帖子无关的作者个人特质，包括但不限于人格、动机、态度、地位或处境等，作为驳斥或论证的依据。</p>
        <p>3. 对特定身份或群体的歧视、侮辱言论：包括但不限于针对特定民族、种族、宗教、性取向、性别、年龄、地域、生理特征等。</p>
        <p>4. 广告和推广内容：如售卖产品、服务，包含推广返利性质的链接、代码，派发红包等。</p>
        <p>5. 恶意揣测、发泄抱怨的评论：如无依据地指责社区帖子具有推广性质，宽泛地批判社区帖子的质量。</p>
        <p>6. 煽动对立的内容：如渲染用户群体间的矛盾，有偏向地对比，在讨论中恶意关联争议性话题等。</p>
        <p>7. 误导性内容：如陈述明显错误的事实，虚构身份、经历、关联关系等。</p>
        <p>8. 盗版或有害内容：如违反相关许可协议提供链接、种子、序列号、注册机，介绍获取盗版的渠道、方法，发布指向钓鱼网站、木马、病毒的链接等。</p>
        <p>9. 无意义内容：如「沙发」「顶」或堆砌表情符号、表情图片、特殊字符等。</p>
        <p>10. 试图通过谐音、符号、图片、影射、暗喻等方式规避上述规则的内容。</p>
        <p>11.其他小睡眠官方依判断认为不合适的内容。</p>
        <h2>社区违规处理</h2>
        <p>1.小睡眠的所有用户均有责任和义务举报或反馈小睡眠不欢迎、禁止的内容；</p>
        <p>2.用户之间的争执均由用户协商解决；</p>
        <p>3.如发现任何小睡眠不欢迎、禁止的内容或违法违规的信息，小睡眠的工作人员有责权介入并依法依规处理。</p>
        <p>4.遇到特殊情况或政府相关机构要求时，小睡眠保留处置或删除用户产生的全部内容的权利，并依法将违规信息上报监管部门。</p>
        <p>5.如果社区帖子或其评论存在下列情形，小睡眠可能自始或中途关闭帖子与评论，或经人工审核后再展示：</p>
        <p>●帖子纯粹起通告或宣传推广作用；</p>
        <p>●现有评论表现出偏离主题、情绪激化、快速堆积等倾向；</p>
        <p>●帖子内容具有潜在争议性，需要保护作者或其隐私；</p>
        <p>●帖子时效过于久远，继续讨论价值有限，易造成误导或打扰；</p>
        <p>●其他小睡眠官方判断认为需要控制内容的场合。</p>
        <h2>反馈渠道</h2>
        <p>当用户违反社区协议，小睡眠将对其违规内容和用户做出相应处理及通知。对处理结果有任何异议，均可通过APP-帮助与客服-进行申诉反馈。</p>
        <h2>附则</h2>
        <p>小睡眠可根据互联网及自身平台的不断发展，随着社区管理经验的不断丰富，出于维护小睡眠社区秩序的目的，不断完善本规范。</p>
        <p>请您再次确认您已全部阅读并充分理解上述协议信息。</p>
        <p>注：本协议更新日期为2024年9月5日，如您认为更新的协议对您更为有利，我们同意双方适用新的协议内容。</p>
        <p class="text-right font-bold mt-4">广州心与潮信息科技有限公司</p>
        <p class="text-right font-bold">2024年9月5日</p>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{

    },
}
</script>

<style lang='scss' scoped>
h1{
    font-size: px2html(24px);
}

h2{
    font-size: px2html(20px);
    font-weight: bold;
    margin: 40px 0 5px;
}
</style>